export default __webpack_public_path__ + "static/Riverside_cap-9f709cdf7d92dca325e70ff174660ace.png";